module.exports = __webpack_public_path__ + "static/img/4856_phase_function_Paper_PointsHejduk_Prediction.7cdd282.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/4856_phase_function_Paper_PointsHejduk_Prediction.png
// module id = aqLI
// module chunks = 0